import { FC } from "react";

interface UpgradeIconProps {
  color: string;
}

const UpgradeIcon: FC<UpgradeIconProps> = ({ color }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 22H7C6.59 22 6.25 21.66 6.25 21.25C6.25 20.84 6.59 20.5 7 20.5H17C17.41 20.5 17.75 20.84 17.75 21.25C17.75 21.66 17.41 22 17 22Z"
        fill={color}
      />
      <path
        d="M20.35 5.51906L16.35 8.37906C15.82 8.75906 15.06 8.52906 14.83 7.91906L12.94 2.87906C12.62 2.00906 11.39 2.00906 11.07 2.87906L9.16998 7.90906C8.93998 8.52906 8.18997 8.75906 7.65998 8.36906L3.65998 5.50906C2.85998 4.94906 1.79998 5.73906 2.12998 6.66906L6.28998 18.3191C6.42998 18.7191 6.80998 18.9791 7.22998 18.9791H16.76C17.18 18.9791 17.56 18.7091 17.7 18.3191L21.86 6.66906C22.2 5.73906 21.14 4.94906 20.35 5.51906ZM14.5 14.7491H9.49998C9.08998 14.7491 8.74998 14.4091 8.74998 13.9991C8.74998 13.5891 9.08998 13.2491 9.49998 13.2491H14.5C14.91 13.2491 15.25 13.5891 15.25 13.9991C15.25 14.4091 14.91 14.7491 14.5 14.7491Z"
        fill={color}
      />
      <defs>
        <linearGradient
          id="paint0_linear_3876_1503"
          x1="7.15025"
          y1="20.2167"
          x2="7.15025"
          y2="22.6167"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#49C172" />
          <stop offset="1" stopColor="#288564" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3876_1503"
          x1="3.62259"
          y1="-0.937798"
          x2="3.62258"
          y2="25.8662"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#49C172" />
          <stop offset="1" stopColor="#288564" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default UpgradeIcon;
